import { useQuery } from "@tanstack/react-query"
import { format } from "date-fns"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import type { SmartRoutingDashboardMetrics } from "@/types/smart-routing"

interface UseSmartRoutingDashboardMetricsParams {
  startDate: Date
  endDate: Date
  enabled?: boolean
}

const useSmartRoutingDashboardMetrics = ({
  startDate,
  endDate,
  enabled = true,
}: UseSmartRoutingDashboardMetricsParams) => {
  return useQuery({
    queryKey: [
      ENDPOINTS.SMART_ROUTING_METRICS,
      format(startDate, "yyyy-MM-dd"),
      format(endDate, "yyyy-MM-dd"),
    ],
    queryFn: async () => {
      if (!startDate || !endDate) {
        throw new Error(
          "startDate and endDate are required"
        )
      }

      const { data } =
        await api.get<SmartRoutingDashboardMetrics>(
          ENDPOINTS.SMART_ROUTING_METRICS,
          {
            params: {
              startDate: format(startDate, "yyyy-MM-dd"),
              endDate: format(endDate, "yyyy-MM-dd"),
            },
          }
        )
      return data
    },
    enabled: Boolean(enabled && startDate && endDate),
  })
}

export default useSmartRoutingDashboardMetrics
